import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/apploader";
import CustomContainer from "../../../components/container/CustomContainer";
import useDebounce from "../../../components/hooks/useDebounce";
import InputField from "../../../components/InputField";
import DynamicTable from "../../../components/table";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { setSearchKeys } from "../../../lib/redux/slices/searchKeysSlice";
import { getUserOrders } from "../../../services/orderFn";
import { t } from "i18next";

const headerData = [
  "orderId",
  "date",
  "tax",
  "totalBill",
  "items",
  "paymentType",
  "action",
];

const tableRows = [
  "order_id",
  "date_time",
  "total_tax",
  "total_bill",
  "order_item",
  "paymentType",
  "order_detail",
];

const PurchaseInvoice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [allOrders, setAllOrders] = useState([]);
  const userData = useSelector((state) => state.userReducer.user);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const debouncedSearchTerm = useDebounce(searchKeys.orderId, 1000);

  useEffect(() => {
    if (userData) {
      fetchAllOrders(debouncedSearchTerm);
    }
  }, [userData, debouncedSearchTerm]);

  const fetchAllOrders = async (orderId) => {
    const query = {
      orderId: orderId || "",
    };
    try {
      setIsLoading(true);
      const response = await getUserOrders(userData._id, query);
      if (response?.data.status === "success") {
        let data = response?.data?.data.orders;
        setAllOrders(data);
      } else {
        showSnackbar(response?.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const renderSearchAction = () => {
    return (
      <Stack p={2} direction={{ md: "row" }} bgcolor={"primary.light"}>
        <InputField
          styleProps={{ width: { xs: "100%", md: "35%", xl: "30%" } }}
          InputStartIcon={<SearchIcon />}
          InputEndIcon={
            searchKeys.orderId && (
              <CancelOutlinedIcon
                fontSize="small"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(
                    setSearchKeys({
                      ...searchKeys,
                      orderId: "",
                    })
                  );
                }}
              />
            )
          }
          placeholder={t("searchByOrderId")}
          value={searchKeys.orderId}
          onChange={(e) => {
            dispatch(
              setSearchKeys({
                ...searchKeys,
                orderId: e.target.value,
              })
            );
          }}
        />
      </Stack>
    );
  };

  const handleNavigateToOrderDetail = (row) => {
    navigate(`/dashboard/e-commerce/orders/${row._id}`);
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("orderHistory")}
        secondaryHeading={t("viewOrderStatus")}
        menuBarProps={renderSearchAction()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allOrders}
          handleViewDetail={handleNavigateToOrderDetail}
        />
      </CustomContainer>
    </>
  );
};

export default PurchaseInvoice;
